import { useContext } from "react";
import context, { IProjectSearchProviderContext } from "../state/context";

export default (): IProjectSearchProviderContext => useContext(context);
